import assetPath from '/app/xinglets/career-hub/bewerbung-topic-page/src/bewerbung-topic-page/lebenslauf-section/assets/lebenslauf-section-first-image.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')